import { PROJECT_COMPLIANCE_STATUS, PROJECT_COMPLIANCE_STATUS_LABELS } from '../../constants';
import { ProjectComplianceStatus } from '../../types';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { Badge } from 'framework/ui/mui-builder';

const ProjectComplianceStatusField = ({ source }: FieldProps<ProjectComplianceStatus>) => {
  const { getValue } = useFieldHelper<ProjectComplianceStatus>({ source });
  const status = getValue();

  return (
    <Badge color={status === PROJECT_COMPLIANCE_STATUS.COMPLIANT ? 'success' : 'error'}>
      {PROJECT_COMPLIANCE_STATUS_LABELS[status]}
    </Badge>
  );
};

export default ProjectComplianceStatusField;
